import {
  Business,
  ConfirmationNumber,
  Event,
  NotificationsActiveOutlined,
  Password,
  Person,
  Upgrade,
  VisibilityOff,
} from "@mui/icons-material";
import { TICKETING_ENABLED } from "../constants/constants";
import { MenuRoute } from "./MenuRoute";

export const UserRoutes: MenuRoute[] = [
  { text: "Profile", href: "/account", icon: () => <Person /> },
  { text: "My Events", href: "/account/events", icon: () => <Event /> },
  ...(TICKETING_ENABLED
    ? [
        {
          text: "My Tickets",
          href: "/account/tickets",
          icon: () => <ConfirmationNumber />,
        },
      ]
    : []),
  {
    text: "Organizations",
    href: "/account/organizations",
    icon: () => <Business />,
  },
  {
    text: "My Plan",
    href: "/subscription",
    icon: () => <Upgrade />,
  },
  {
    text: "Hidden Events",
    href: "/account/events/hidden",
    icon: () => <VisibilityOff />,
  },
  {
    text: "Following",
    expandable: true,
    expanded: false,
    icon: () => <NotificationsActiveOutlined />,
    subRoutes: [
      {
        text: "Events",
        href: "/account/events/following",
        icon: () => <Event />,
      },
      {
        text: "Organizations",
        href: "/account/organizations/following",
        icon: () => <Business />,
      },
    ],
  },
  {
    text: "Password",
    href: "/account/change-password",
    icon: () => <Password />,
  },
];
